/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Close, HttpsOutlined } from '@mui/icons-material';
import SettingAction from '../../store/actions/SettingAction';
import { ValidateChangePassword } from '../../assets/validation';

function ChangePassword({ openmodal, onCloseModal }) {
  const dispatch = useDispatch();

  return (
    <div>
      <Modal
        className="cmn__form__modal"
        keepMounted
        open={openmodal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <Formik
            initialValues={{
              current_password: '',
              password: '',
              password_confirmation: ''
            }}
            enableReinitialize
            validationSchema={ValidateChangePassword}
            onSubmit={(values, { setErrors, setSubmitting }) => {
              dispatch(
                SettingAction.updateChangePassword(values, setErrors, setSubmitting, onCloseModal)
              );
            }}
          >
            {({
              errors,
              touched,
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              handleReset,
              isSubmitting
            }) => (
              <form onSubmit={handleSubmit}>
                <Card>
                  <CardHeader
                    title="Change Password"
                    action={
                      <IconButton
                        aria-label="settings"
                        onClick={() => {
                          onCloseModal();
                        }}
                      >
                        <Close />
                      </IconButton>
                    }
                  />
                  <CardContent>
                    <TextField
                      id="filled-current_password-input"
                      fullWidth
                      label="Current Password"
                      name="current_password"
                      type="password"
                      autoComplete="current_password"
                      margin="normal"
                      error={errors.current_password && touched.current_password}
                      value={values.current_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={
                        errors.current_password &&
                        touched.current_password &&
                        errors.current_password
                      }
                      required={false}
                      InputLabelProps={{ required: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              disabled
                              // color="secondary"
                            >
                              <HttpsOutlined />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    <TextField
                      id="filled-password-input"
                      fullWidth
                      label="New password"
                      name="password"
                      type="password"
                      autoComplete="password"
                      margin="normal"
                      error={errors.password && touched.password}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={errors.password && touched.password && errors.password}
                      required={false}
                      InputLabelProps={{ required: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              disabled
                              // color="secondary"
                            >
                              <HttpsOutlined />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    <TextField
                      id="filled-password_confirmation-input"
                      fullWidth
                      label="Confirm Password"
                      name="password_confirmation"
                      type="password"
                      autoComplete="password_confirmation"
                      margin="normal"
                      error={errors.password_confirmation && touched.password_confirmation}
                      value={values.password_confirmation}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={
                        errors.password_confirmation &&
                        touched.password_confirmation &&
                        errors.password_confirmation
                      }
                      required={false}
                      InputLabelProps={{ required: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              disabled
                              // color="secondary"
                            >
                              <HttpsOutlined />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'center' }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </form>
            )}
          </Formik>
        </Box>
      </Modal>
    </div>
  );
}

ChangePassword.propTypes = {
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ChangePassword;
